import { makeStyles, Tooltip, Typography } from "@material-ui/core";
import { Publish } from "@material-ui/icons";
import DataIcon from "@material-ui/icons/Storage";
import { useHistory } from "react-router-dom";
import { createRoute } from "utils/url";
import { useQueryUseCaseDataCount } from "../calculate/calculationHooks";
import Topic from "../Topic";
import DataCountError from "./DataCountError";

const useStyles = makeStyles(theme => ({
  right: {
    flex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    textTransform: "capitalize",
    padding: theme.spacing(1),
    flexDirection: "column"
  },
  text: {
    textAlign: "left",
    color: "#fff",
    width: "100%",
    textTransform: "capitalize",
    fontWeight: "bold"
  },
  iconWithBackground: {
    fontSize: 30,
    backgroundColor: "#fff",
    color: "rgba(0,153,203,0.7)",
    borderRadius: 2
  },
  topicColor: {
    backgroundColor: theme.palette.secondary.main,
    marginRight: theme.spacing(4)
  },
  icon: { marginRight: 16, fontSize: 60 },
  uploadButton: { position: "absolute", top: 0, right: 0, padding: 24 },
  number: { fontSize: 60, marginRight: 8 },
  dialogTitle: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white
  }
}));

type DataCardProps = {
  useCaseKey: string;
  useCaseVersion: string;
};

export default function DataCard({
  useCaseKey,
  useCaseVersion
}: DataCardProps) {
  const classNames = useStyles();

  const {
    data: dataCount,
    loading,
    error: dataCountError
  } = useQueryUseCaseDataCount({
    useCaseKey
  });

  const history = useHistory();
  const noData =
    (!dataCount || dataCount.cloudPlatform.useCase?.dataCount === 0) &&
    !dataCountError;

  const toolTipTitle = noData ? "Be the first to upload new data" : undefined;

  return (
    <Topic
      title="Data"
      icon={<DataIcon fontSize="large" className={classNames.icon} />}
      count={
        !dataCountError ? (
          <Typography className={classNames.number}>
            {dataCount?.cloudPlatform.useCase?.dataCount}
          </Typography>
        ) : (
          <DataCountError error={dataCountError} />
        )
      }
      isLoading={loading}
      dataTest="topic-upload-data"
      toolTipTitle={toolTipTitle}
      to={
        noData
          ? `/use-cases/${useCaseKey}/${useCaseVersion}/upload-data`
          : "./data"
      }
      colorClassName={classNames.topicColor}
    >
      {!noData ? (
        <Tooltip title="Upload new data">
          <div className={classNames.uploadButton}>
            <Publish
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                history.push(
                  createRoute(
                    `/use-cases/${useCaseKey}/${useCaseVersion}/upload-data`
                  )
                );
              }}
            />
          </div>
        </Tooltip>
      ) : null}
    </Topic>
  );
}
